import { FunctionComponent } from 'react';
import { RoutingProfileListSubscriber } from '@cbridge-packages/routing-profile';
import { ProfilesLayout } from '../../_layout/ProfilesLayout';

export const ProfilesRoutingLayout: FunctionComponent = () => {
  return (
    <ProfilesLayout>
      <RoutingProfileListSubscriber />
    </ProfilesLayout>
  );
};
